<template>
    <div class="fitting-availability alert p-1 mt-2 mb-0 text-center" :class="fittingClass" data-bs-toggle="tooltip" data-bs-placement="top" :title="tooltipText">
        <p class="mb-0 w-100" style="min-height: 24px;" :class="fittingPlaceholderClass" v-html="fittingText"></p>
    </div>
</template>

<script>
    import dayjs from 'dayjs';

    export default {
        props: ['fittingToday', 'fittingTomorrow', 'earliestFittingDate', 'postcode'],
        data() {
            return {
            }
        },
        created() {
            this.emitter.emit('refreshTooltips');
        },
        updated() {
            // Only refresh tooltips if we have some loaded data.
            if (this.fittingToday !== undefined && this.fittingTomorrow !== undefined && this.earliestFittingDate !== undefined) {
                this.emitter.emit('refreshTooltips');
            }
        },
        methods: {
        },
        computed: {
            twoDaysHence: function() {
                return dayjs().add(2, 'day').format('YYYY-MM-DD');
            },
            fittingPlaceholderClass: function() {
                if((typeof(this.fittingToday) == 'undefined') && (typeof(this.fittingTomorrow) == 'undefined') && (typeof(this.earliestFittingDate) == 'undefined')) {
                    return 'placeholder';
                }
            },
            fittingClass: function() {
                if((typeof(this.fittingToday) == 'undefined') && (typeof(this.fittingTomorrow) == 'undefined') && (typeof(this.earliestFittingDate) == 'undefined')) {
                    return 'placeholder-glow';
                }
                else {
                    return this.fittingToday == true ? 'alert-success' : (this.fittingTomorrow == true ? 'alert-success' : (this.earliestFittingDate <= this.twoDaysHence ? 'alert-warning' : 'alert-warning'));
                }
            },
            fittingText: function() {
                if((typeof(this.fittingToday) == 'undefined') && (typeof(this.fittingTomorrow) == 'undefined') && (typeof(this.earliestFittingDate) == 'undefined')) {
                    return '';
                }
                else {
                    return this.fittingToday == true ? 'Fit Today' : (this.fittingTomorrow == true ? '24h Fitting' : (this.earliestFittingDate <= this.twoDaysHence ? '48h Fitting' : '48h+ Fitting'));
                }
            },
            tooltipText: function() {
                if((typeof(this.fittingToday) == 'undefined') && (typeof(this.fittingTomorrow) == 'undefined') && (typeof(this.earliestFittingDate) == 'undefined')) {
                    return 'Loading fitting availability';
                }
                if(this.fittingToday == true) {
                        return 'Fitting today';
                }
                else if(this.fittingTomorrow == true) {
                    return 'Fitting tomorrow';
                }
                else if(this.earliestFittingDate <= this.twoDaysHence) {
                    return 'Fitting within 2 days';
                }
                else {
                    return 'Fitting after 2 days';
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
</style>